import { Link, useParams } from 'react-router-dom';

export function CertificationDetail() {
  const { code } = useParams<{ code: string }>();

  return (
    <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
      <Link to="/certificaciones" className="text-sm text-text-secondary hover:text-text-primary">
        ← Volver al catalogo
      </Link>

      <h1 className="mt-4 text-4xl font-bold tracking-tight">{code}</h1>
      <p className="mt-2 text-lg text-text-secondary">
        Detalle publico de la certificacion (placeholder — Sprint 3 implementa la pagina completa).
      </p>

      <div className="mt-10 card">
        <h2 className="text-xl font-bold">En construccion</h2>
        <p className="mt-2 text-text-secondary">
          Esta pagina mostrara dominios oficiales, estado del banco de preguntas, recursos
          oficiales relacionados y un CTA para probar 20 preguntas gratis.
        </p>
        <p className="mt-4 text-sm text-text-tertiary">
          Tarea de implementacion: <code className="font-mono">RC-WEB-011</code> — Sprint 3.
        </p>
      </div>
    </div>
  );
}
